import { render } from "./AccountAppleIapMembership.vue?vue&type=template&id=4b45ca5b"
import script from "./AccountAppleIapMembership.vue?vue&type=script&lang=js"
export * from "./AccountAppleIapMembership.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__